import { Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'ftr-drop-overlay',
  templateUrl: './drop-overlay.component.html',
  styleUrls: ['./drop-overlay.component.css'],
  standalone: true,
})
export class DropOverlayComponent {
  @Input() isReadyToDrop: boolean

  @HostBinding('style.width')
  width = '100%'
}
